"use client";

import { useState } from "react";
import { loginAction } from "./actions";

const ERROR_MESSAGES: Record<string, string> = {
  missing_fields: "Inserisci email e password.",
  invalid_credentials: "Credenziali non valide.",
  not_authorized: "Account non autorizzato all'accesso al backoffice.",
};

export function LoginForm({
  redirectTo,
  initialError,
}: {
  redirectTo?: string;
  initialError?: string;
}) {
  const [pending, setPending] = useState(false);
  const errorMsg = initialError ? ERROR_MESSAGES[initialError] ?? "Errore durante l'accesso." : null;

  return (
    <form
      action={async (fd) => {
        setPending(true);
        await loginAction(fd);
      }}
      className="flex flex-col gap-4"
    >
      <input type="hidden" name="redirect" value={redirectTo ?? "/"} />

      <label className="flex flex-col gap-1.5">
        <span className="text-xs uppercase tracking-wide" style={{ color: "var(--text-muted)" }}>
          Email
        </span>
        <input
          name="email"
          type="email"
          required
          autoComplete="email"
          className="rounded px-3 py-2 outline-none border"
          style={{
            background: "var(--surface-light)",
            borderColor: "var(--border-light)",
            color: "var(--text)",
          }}
        />
      </label>

      <label className="flex flex-col gap-1.5">
        <span className="text-xs uppercase tracking-wide" style={{ color: "var(--text-muted)" }}>
          Password
        </span>
        <input
          name="password"
          type="password"
          required
          autoComplete="current-password"
          className="rounded px-3 py-2 outline-none border"
          style={{
            background: "var(--surface-light)",
            borderColor: "var(--border-light)",
            color: "var(--text)",
          }}
        />
      </label>

      {errorMsg && (
        <div
          className="text-sm rounded px-3 py-2 border"
          style={{
            color: "var(--danger)",
            borderColor: "var(--danger)",
            background: "rgba(239, 83, 80, 0.08)",
          }}
        >
          {errorMsg}
        </div>
      )}

      <button
        type="submit"
        disabled={pending}
        className="rounded px-4 py-2.5 font-medium transition-opacity disabled:opacity-60 mt-2"
        style={{ background: "var(--gold)", color: "#000" }}
      >
        {pending ? "Accesso..." : "Entra"}
      </button>
    </form>
  );
}
